import MerchantCompanyPage from '../pages/MerchantCompanyPage.vue';
import MerchantCompaniesPage from '../pages/MerchantCompaniesPage.vue';
import MerchantCompanyInformationPage from '../pages/MerchantCompanyInformationPage.vue';
import MerchantCompanyEditPage from '../pages/MerchantCompanyEditPage.vue';

const merchantCompanyRoutes = [
  {
    path: '/merchant-companies/list',
    name: 'لیست کسب و کارها',
    component: MerchantCompaniesPage,
    meta: {
      roles: ['supplier'],
    },
  },
  {
    path: '/merchant-companies/add',
    name: 'ثبت کسب و کار',
    component: MerchantCompanyPage,
    meta: {
      roles: ['supplier'],
    },
  },
  {
    path: '/merchant-companies/:id/information',
    name: 'مشاهده کسب و کار',
    component: MerchantCompanyInformationPage,
    meta: {
      roles: ['supplier'],
    },
  },
  {
    path: '/merchant-companies/:id/edit',
    name: 'ویرایش کسب و کار',
    component: MerchantCompanyEditPage,
    meta: {
      roles: ['supplier'],
    },
  },
];

export default merchantCompanyRoutes;
